'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/payment-pages/payment-failure.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRouterDom = require('react-router-dom');
var _propTypes = require('prop-types');
var _button = require('@marmalade/button');
var _paymentFailure = require('../../media/payment-failure.svg');
var _paymentFailure2 = _interopRequireDefault(_paymentFailure);
var _notificationPage = require('./notification-page');
var _notificationPage2 = _interopRequireDefault(_notificationPage);
var _notificationTelephone = require('./notification-telephone');
var _notificationTelephone2 = _interopRequireDefault(_notificationTelephone);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
PaymentFailure.propTypes = {
  tryAgainLink: _propTypes.string.isRequired,
  container: _propTypes.bool.isRequired
};
function PaymentFailure(_ref) {
  var tryAgainLink = _ref.tryAgainLink,
    container = _ref.container;
  return _react2.default.createElement(_notificationPage2.default, {
    container: container,
    Img: _react2.default.createElement('img', {
      width: '200rem',
      src: _paymentFailure2.default,
      alt: 'Payment failed',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 18
      },
      __self: this
    }),
    title: 'Sorry, your payment was unsuccessful :(',
    text: _react2.default.createElement(_react.Fragment, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 21
      },
      __self: this
    }, 'You can call us on ', _react2.default.createElement(_notificationTelephone2.default, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 22
      },
      __self: this
    }), ' for assistance or alternatively', ' ', _react2.default.createElement(_reactRouterDom.Link, {
      to: tryAgainLink,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 23
      },
      __self: this
    }, 'try again'), '.'),
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16
    },
    __self: this
  }, _react2.default.createElement(_button.LinkButton, {
    block: true,
    to: tryAgainLink,
    prominence: 'primary',
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27
    },
    __self: this
  }, 'Try Again'))
  // <Div backgroundColor="#f9f9f9" marginTop="-3rem">
  //     <Element>
  //         <Main
  //             display="flex"
  //             flexDirection="column"
  //             alignItems="center"
  //             margin="10rem "
  //         >

  //         </Main>
  //     </Element>
  // </Div>
  ;
}
exports.default = PaymentFailure;